// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TeamMembers_wrapper__DiL7r","teamMembers":"TeamMembers_teamMembers__NYBsT","member":"TeamMembers_member__nmrD3","image":"TeamMembers_image__QOs16"};